import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutWireCodeForWireFundsLookup extends Layout {
    sourceWirecode: DataSource;
    tableWireCodeLookup: Table;
}
